import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "33d2fa29-cb25-4ce4-b9ed-f80cd479bdd4", content: "~15 dB", options: {} },
  { id: "9ee3a7be-e007-45b6-8177-63620db8a1e2", content: "~10 dB", options: {} },
  { id: "15bb1a9b-21fd-4826-b18a-4bbb00a56ccd", content: "~7-8 dB", options: {} },
  { id: "cd6bda0f-d60a-4aea-b44e-e8e114c2e773", content: "~3 dB", options: {} },
];

export const task: Task = {
  id: "46d64499-04bb-4828-b00e-796812aa16b8",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["15bb1a9b-21fd-4826-b18a-4bbb00a56ccd"],
};
